$(document).ready(function(){
  $('.evaluation-item').on('click', '.previous-step', function(e) {
    e.preventDefault();

    if ($(this).parents('.evaluation-item').prev().length > 0) {
      $(this).parents('.evaluation-item').addClass('hidden');
      $(this).parents('.evaluation-item').prev().removeClass('hidden');
    }
  });

  $('.evaluation-item').on('click', '.next-step', function(e) {
    e.preventDefault();

    if ($(this).parents('.evaluation-item').next().length > 0) {
      $(this).parents('.evaluation-item').addClass('hidden');
      $(this).parents('.evaluation-item').next().removeClass('hidden');
    }
  });
});
